//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import Swal from "sweetalert2";

export default {
    name: "QuotationList",
    data() {
        return {
            myDepartment: null,

            searchInput: "",
            search: "",
            filterDocType: null,
            // filterStatus: null,
            filterDepartment: null,

            dateFrom: this.getFirstDayOfMonth(),
            dateTo: this.getToday(),
            menuFrom: false,
            menuTo: false,

            dialogDelete: false,
            deleteTarget: null,
            isLoadingTable: false,

            docTypeOptions: [
                { text: "Quotation (Fixed Price)", value: "fixed" },
                { text: "Fee Estimate", value: "estimate" },
            ],
            statusOptions: [
                { text: "Draft", value: "Draft" },
                { text: "Submitted", value: "Submitted" },
                { text: "In Progress", value: "InProgress" },
                { text: "Invoiced", value: "Invoiced" },
            ],

            headers: [
                { text: "Document No.", value: "doc_no", divider: true, width: "150px" },
                { text: "Date", value: "doc_date_show", divider: true, width: "100px" },
                { text: "Client", value: "client_name", divider: true, width: "220px" },
                { text: "Department", value: "department", divider: true, width: "110px" },
                { text: "Doc Type", value: "doc_type", divider: true, width: "130px" },
                { text: "Total Amount", value: "grand_total_show", divider: true, align: "end", width: "150px" },
                { text: "Currency", value: "currency", divider: true, align: "end", width: "90px" },
                { text: "Status", value: "status", divider: true, width: "140px" },
                { text: "Editor", value: "user_create", divider: true, width: "90px" },
                { text: "", value: "actions", divider: true, width: "100px", sortable: false },
            ],

            items: [],
            clientOptions: [],
            departmentList: [],
        };
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
            this.myDepartment = localStorage.getItem(server.DEPARTMENT_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            console.error("QuotationList mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        // ===== โหลดข้อมูลจริง แยก catch ออกจาก auth =====
        this.$showLoader();
        try {
            await this.loadCustomer();
            await this.loadDepartment();

            // ถ้าไม่ใช่ admin ล็อค filterDepartment ให้เป็นแผนกตัวเองตั้งแต่แรก
            if (!this.isAdmin) {
                this.filterDepartment = this.myDepartment;
            }

            await this.loadQuotations();
        } catch (error) {
            console.error("QuotationList mounted() load data error:", error);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถโหลดข้อมูลรายการได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    computed: {
        isAdmin() {
            return localStorage.getItem(server.ROLE) === "ADMIN"; // เดิมถูกอยู่แล้ว ใช้ === เทียบตรงๆ ได้เลย
        },
        // ✅ กลับไปแบบเดิม — derive จาก items ที่มีอยู่จริง ไม่ดึงทุกแผนกของบริษัท
        departmentOptions() {
            const depts = this.items.map((d) => d.department).filter(Boolean);
            return [...new Set(depts)].sort();
        },
        filteredItems() {
            return this.items;
        },
    },
    watch: {
        // ✅ ทุก filter เปลี่ยน → ยิง API ใหม่
        filterDocType() {
            this.loadQuotations();
        },
        filterStatus() {
            this.loadQuotations();
        },
        filterDepartment() {
            this.loadQuotations();
        },
        dateFrom() {
            this.loadQuotations();
        },
        dateTo() {
            this.loadQuotations();
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
    methods: {
        getFirstDayOfMonth() {
            const d = new Date();
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            return `${yyyy}-${mm}-01`;
        },
        getToday() {
            const d = new Date();
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        },
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: {
                    company_id: localStorage.getItem(server.COMPANYID),
                },
            });
            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                name: item.name,
            }));
        },
        async loadDepartment() {
            const res = await api.getAllDepartment_By_CompanyID(
                Number(localStorage.getItem(server.COMPANYID))
            );

            this.departmentList = res.data.map((d) => ({
                id: d.id,
                name: d.department_name,
            }));
        },
        // ✅ หา department_id จากชื่อที่เลือกใน dropdown (dropdown เก็บเป็นชื่อ ไม่ใช่ id)
        getDepartmentIdByName(name) {
            const match = this.departmentList.find((d) => d.name === name);
            return match ? match.id : null;
        },
        async loadQuotations() {
            this.isLoadingTable = true;
            try {
                const params = {
                    company_id: Number(localStorage.getItem(server.COMPANYID)),
                    role: localStorage.getItem(server.ROLE) || "",
                };

                if (this.filterDocType) params.doc_type = this.filterDocType;
                // if (this.filterStatus) params.status = this.filterStatus;
                if (this.dateFrom) params.dateFrom = this.dateFrom;
                if (this.dateTo) params.dateTo = this.dateTo;
                if (this.search) params.keyword = this.search;

                if (!this.isAdmin) {
                    params.department_id = this.myDepartment;
                } else if (this.filterDepartment) {
                    const deptId = this.getDepartmentIdByName(this.filterDepartment);
                    if (deptId) params.department_id = deptId;
                }

                const res = await api.billing_expense_adjustQuotations(Number(localStorage.getItem(server.COMPANYID)), params);
                const list = Array.isArray(res.data) ? res.data : [];

                this.items = list.map((record) => ({
                    id: record.quotation_id,
                    doc_no: record.doc_no,
                    doc_date: record.doc_date,
                    doc_date_show: this.formatDocDateShow(record.doc_date),
                    client_name: record.client ? record.client.name : `Client #${record.client_id}`,
                    department: record.department ? record.department.name : "-",
                    department_id: record.department_id,
                    doc_type: record.doc_type,
                    grand_total: record.grand_total,
                    currency: record.currency,
                    status: record.status,
                    user_create: record.creator ? this.getUserDisplayName(record.creator) : `User #${record.user_create}`,
                }));
            } catch (error) {
                console.error("loadQuotations error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลรายการได้",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                this.isLoadingTable = false;
            }
        },
        getUserDisplayName(u) {
            const enFirst = (u.firstname_e_n || "").trim();
            const enLast = (u.lastname_e_n || "").trim();

            if (enFirst || enLast) {
                return `${enFirst} ${enLast}`.trim();
            }

            const thFirst = (u.firstname || "").trim();
            const thLast = (u.lastname || "").trim();
            return `${thFirst} ${thLast}`.trim();
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },
        applySearch() {
            this.search = this.searchInput;
            this.loadQuotations(); // ✅ ยิง API ใหม่ตอนกด enter/search
        },
        clearSearch() {
            this.searchInput = "";
            this.search = "";
            this.loadQuotations(); // ✅ ยิง API ใหม่ตอน clear
        },
        fmt(n) {
            if (n === null || n === undefined) return "-";
            return Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        statusColor(status) {
            return { Draft: "grey", Submitted: "blue", Invoiced: "green", InProgress: "purple" }[status] || "grey";
        },
        statusIcon(status) {
            return status === "Draft" ? "✏️" : status === "Invoiced" || status === "InProgress" ? "🔒" : "";
        },
        statusLabel(status) {
            return { Draft: "Draft", Submitted: "Submitted", Invoiced: "Invoiced", InProgress: "In Progress" }[status];
        },
        canDelete(item) {
            return item.status === "Draft";
        },
        onEdit(item) {
            this.$router.push(`/edit-quotation/${item.id}`);
        },
        onView(item) {
            this.$router.push(`/view-quotation/${item.id}`);
        },
        onAdjust(item) {
            this.$router.push(`/adjust-quotation-edit/${item.id}`);
        },
        onDelete(item) {
            this.deleteTarget = item;
            this.dialogDelete = true;
        },
        async confirmDelete() {
            const id = this.deleteTarget.id;
            this.dialogDelete = false;
            this.$showLoader();

            try {
                const res = await api.billing_expense_updateQuotations(id, {
                    is_deleted: true, modeUpdate: "deleteData"
                });

                if (res.status == 200) {
                    await this.loadQuotations();
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: "ลบสำเร็จ",
                        text: "ลบใบเสนอราคาเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                }
            } catch (error) {
                console.error("confirmDelete error:", error);
                this.$hideLoader();
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: error.response?.data?.message || "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                this.deleteTarget = null;
            }
        },
    },
};
